import { render, staticRenderFns } from "./SiswaList.vue?vue&type=template&id=5bfec8db&scoped=true"
import script from "./SiswaList.vue?vue&type=script&lang=js"
export * from "./SiswaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfec8db",
  null
  
)

export default component.exports